export default __webpack_public_path__ + "static/media/arrow.9b1977b0.svg";